<template>
  <section>
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px">
      <el-form :inline="true" :model="search">
        <el-form-item label="酒店">
          <el-select
            filterable
            v-model="search.hotel_id"
            placeholder="选择酒店"
            clearable
          >
            <el-option
              v-for="item in hotels"
              :value="item[0]"
              :key="item[0]"
              :label="item[1].tzName || item[1].dltName"
            >
              <span style="float: left">{{ item[1].tzName }}</span>
              <span style="float: right">{{ item[1].dltName }}</span>
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="日期">
          <el-date-picker
            v-model="search.range"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="房型名">
          <el-input v-model="search.name" clearable />
        </el-form-item>
        <el-form-item label="早餐数">
          <el-input type="number" v-model="search.breakfirst" clearable />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="getTpls">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增价格</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchEdit"
            >批量修改</el-button
          >
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleBatchDel">批量删除</el-button>
        </el-form-item>
      </el-form>
    </el-col>
    <el-dialog
      title="新增"
      v-model="addFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="addForm" label-width="80px" ref="addForm">
        <el-form-item label="酒店">
          <el-select
            filterable
            v-model="addForm.hotel_id"
            placeholder="选择酒店"
            clearable
          >
            <el-option
              v-for="item in hotels"
              :value="item[0]"
              :key="item[0]"
              :label="item[1].tzName || item[1].dltName"
            >
              <span style="float: left">{{ item[1].tzName }}</span>
              <span style="float: right">{{ item[1].dltName }}</span>
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="选择日期">
          <el-date-picker
            v-model="addForm.range"
            type="daterange"
            align="right"
            placeholder="选择日期范围"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用星期">
          <el-select multiple v-model="addForm.weekdays" style="width: 500px">
            <el-option :value="1" label="周一"></el-option>
            <el-option :value="2" label="周二"></el-option>
            <el-option :value="3" label="周三"></el-option>
            <el-option :value="4" label="周四"></el-option>
            <el-option :value="5" label="周五"></el-option>
            <el-option :value="6" label="周六"></el-option>
            <el-option :value="0" label="周日"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房型">
          <el-input placeholder="输入房型" v-model="addForm.name"></el-input>
        </el-form-item>
        <el-form-item label="早餐数">
          <el-input
            type="number"
            placeholder="输入早餐数"
            v-model="addForm.breakfirst"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格">
          <el-input
            type="number"
            placeholder="输入价格"
            v-model="addForm.price"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="addFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="addSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量删除"
      v-model="batchDeleteVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="batchDeleteForm"
        label-width="80px"
        ref="batchDeleteForm"
      >
        <el-form-item label="酒店" required>
          <el-select
            filterable
            v-model="batchDeleteForm.hotel_id"
            placeholder="选择酒店"
            clearable
          >
            <el-option
              v-for="item in hotels"
              :value="item[0]"
              :key="item[0]"
              :label="item[1].tzName || item[1].dltName"
            >
              <span style="float: left">{{ item[1].tzName }}</span>
              <span style="float: right">{{ item[1].dltName }}</span>
            </el-option>
          </el-select>
          <span>必须选择酒店</span>
        </el-form-item>

        <el-form-item label="选择日期">
          <el-date-picker
            v-model="batchDeleteForm.range"
            type="daterange"
            align="right"
            placeholder="选择日期范围"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用星期">
          <el-select
            multiple
            v-model="batchDeleteForm.weekdays"
            style="width: 500px"
          >
            <el-option :value="1" label="周一"></el-option>
            <el-option :value="2" label="周二"></el-option>
            <el-option :value="3" label="周三"></el-option>
            <el-option :value="4" label="周四"></el-option>
            <el-option :value="5" label="周五"></el-option>
            <el-option :value="6" label="周六"></el-option>
            <el-option :value="0" label="周日"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房型">
          <el-input
            placeholder="输入房型"
            v-model="batchDeleteForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="早餐数">
          <el-input
            style="width: 80px"
            type="number"
            placeholder="输入早餐数"
            v-model="batchDeleteForm.breakfirst"
          ></el-input>
          <span>早餐数为0代表无早，删除不填代表不作为搜索条件</span>
        </el-form-item>
        <el-form-item label="价格">
          <el-input
            type="number"
            placeholder="输入价格"
            v-model="batchDeleteForm.price"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="batchDeleteVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="batchDeleteSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="批量修改价格"
      v-model="batchEditVisible"
      :close-on-click-modal="false"
    >
      <el-form
        :model="batchEditForm"
        label-width="80px"
        ref="batchEditForm"
      >
        <el-form-item label="酒店" required>
          <el-select
            filterable
            v-model="batchEditForm.hotel_id"
            placeholder="选择酒店"
            clearable
          >
            <el-option
              v-for="item in hotels"
              :value="item[0]"
              :key="item[0]"
              :label="item[1].tzName || item[1].dltName"
            >
              <span style="float: left">{{ item[1].tzName }}</span>
              <span style="float: right">{{ item[1].dltName }}</span>
            </el-option>
          </el-select>
          <span>必须选择酒店</span>
        </el-form-item>

        <el-form-item label="选择日期">
          <el-date-picker
            v-model="batchEditForm.range"
            type="daterange"
            align="right"
            placeholder="选择日期范围"
            :picker-options="pickerOptions"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="适用星期">
          <el-select
            multiple
            v-model="batchEditForm.weekdays"
            style="width: 500px"
          >
            <el-option :value="1" label="周一"></el-option>
            <el-option :value="2" label="周二"></el-option>
            <el-option :value="3" label="周三"></el-option>
            <el-option :value="4" label="周四"></el-option>
            <el-option :value="5" label="周五"></el-option>
            <el-option :value="6" label="周六"></el-option>
            <el-option :value="0" label="周日"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="房型">
          <el-input
            placeholder="输入房型"
            v-model="batchEditForm.name"
          ></el-input>
        </el-form-item>
        <el-form-item label="早餐数">
          <el-input
            type="number"
            style="width: 80px"
            placeholder="输入早餐数"
            v-model="batchEditForm.breakfirst"
          ></el-input>
          <span>早餐数为0代表无早，删除不填代表不作为搜索条件</span>
        </el-form-item>
        <el-form-item label="价格">
          <el-input
            type="number"
            placeholder="输入价格"
            v-model="batchEditForm.price"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="batchEditVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="batchEditSubmit"
          :loading="addLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      title="编辑"
      v-model="editFormVisible"
      :close-on-click-modal="false"
    >
      <el-form :model="editForm" label-width="80px" ref="addForm">
        <el-form-item label="酒店">
          <el-input
            disabled
            :placeholder="
              hotelMap[editForm.hotel_id] && hotelMap[editForm.hotel_id].tzName
            "
          ></el-input>
        </el-form-item>

        <el-form-item label="选择日期">
          <el-date-picker
            v-model="editForm.tpl_date"
            align="right"
            disabled
            placeholder="选择日期"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="房型">
          <el-input placeholder="输入房型" v-model="editForm.name"></el-input>
        </el-form-item>
        <el-form-item label="早餐数">
          <el-input
            type="number"
            placeholder="输入早餐数"
            v-model="editForm.breakfirst"
          ></el-input>
        </el-form-item>
        <el-form-item label="价格">
          <el-input
            type="number"
            placeholder="输入价格"
            v-model="editForm.price"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click.native="editFormVisible = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="editSubmit"
          :loading="editLoading"
          >提交</el-button
        >
      </div>
    </el-dialog>
    <template v-if="tableType === 1">
      <el-table
        :data="tpls"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        fixed
      >
        <el-table-column
          width="300"
          prop="hotel_id"
          label="酒店名"
          :formatter="
            (row) =>
              row.hotel_id
                ? (hotelMap[row.hotel_id] &&
                    hotelMap[row.hotel_id][
                      fromNameMap[row.from] || 'tzName'
                    ]) ||
                  '-'
                : '-'
          "
        ></el-table-column>
        <el-table-column width="200" prop="name" label="房型名" />
        <el-table-column width="80" prop="breakfirst" label="早餐" />
        <el-table-column
          width="150"
          prop="tpl_date"
          label="日期"
          :formatter="(row) => formatDate(row)"
        />
        <el-table-column width="150" prop="price" label="价格" />
        <el-table-column label="操作" width="200">
          <template scope="scope">
            <el-button
              size="small"
              type="primary"
              @click="handleEdit(scope.$index, scope.row)"
              >编辑</el-button
            >

            <el-button
              size="small"
              type="danger"
              @click="handleDel(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-col :span="24" class="toolbar">
        <el-pagination
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="20"
          :total="total"
          style="float: right"
        ></el-pagination>
      </el-col>
    </template>
    <div v-else style="clear: both">
      <el-collapse>
        <el-collapse-item v-for="d in Object.keys(listRes)" :title="d" :key="d">
          <el-table
            :data="listRes[d]"
            highlight-current-row
            style="width: 100%"
            fixed
          >
            <el-table-column
              width="300"
              prop="hotel_id"
              label="酒店名"
              :formatter="
                (row) =>
                  row.hotel_id
                    ? (hotelMap[row.hotel_id] &&
                        hotelMap[row.hotel_id][
                          fromNameMap[row.from] || 'tzName'
                        ]) ||
                      '-'
                    : '-'
              "
            ></el-table-column>
            <el-table-column width="200" prop="name" label="房型名" />
            <el-table-column width="80" prop="breakfirst" label="早餐" />
            <el-table-column
              width="150"
              prop="tpl_date"
              label="日期"
              :formatter="(row) => formatDate(row)"
            />
            <el-table-column width="150" prop="price" label="价格" />
            <el-table-column label="操作" width="200">
              <template scope="scope">
                <el-button
                  size="small"
                  type="primary"
                  @click="handleEdit(scope.$index, scope.row)"
                  >编辑</el-button
                >

                <el-button
                  size="small"
                  type="danger"
                  @click="handleDel(scope.row.id)"
                  >删除</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </el-collapse-item>
      </el-collapse>
    </div>
  </section>
</template>

<script>
import fecha from "fecha";
import { adminApi, hotelApi, orderApi } from "../../api/api";
import {
  tzOrderStatusMap,
  handleStatusMap,
  fromMap,
  fromNameMap,
} from "../../constant";

export default {
  data() {
    return {
      search: {
        hotel_id: "",
        range: [],
        name: '',
        breakfirst: ''
      },
      hotels: [],
      hotelMap: {},
      fromNameMap,
      addFormVisible: false,
      editFormVisible: false,
      addLoading: false,
      editLoading: false,
      tableType: 1,
      listRes: {},
      addForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: 0,
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      },
      editForm: {
        hotel_id: "",
        date: "",
        name: "",
        price: 0,
        breakfirst: 0,
      },
      page: 1,
      total: 0,
      listLoading: false,
      tpls: [],
      pickerOptions: {
        shortcuts: [
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      batchDeleteVisible: false,
      batchEditVisible: false,
      batchDeleteForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      },
      batchEditForm: {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      },
    };
  },

  methods: {
    getHotelMap() {
      hotelApi.listMap().then(({ data }) => {
        this.hotelMap = data;
        this.hotels = Object.entries(data);
      });
    },
    handleAdd() {
      this.addForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: 0,
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      };
      this.addLoading = false;
      this.addFormVisible = true;
    },
    handleDel(id) {
      this.$confirm("确认删除吗？", "提示", {}).then(() => {
        orderApi.tplDelete(id).then((res) => {
          this.$message({
            message: "提交成功",
            type: "success",
          });
          this.getTpls();
        });
      });
    },
    //显示编辑界面
    handleEdit: function (index, row) {
      this.editFormVisible = true;
      this.editForm = Object.assign(this.editForm, row);
    },
    addSubmit() {
      this.addLoading = true;
      orderApi
        .tplAdd(this.addForm)
        .then((res) => {
          this.$message({
            message: "创建成功",
            type: "success",
          });
          this.addLoading = false;
          this.addFormVisible = false;
          this.getTpls();
        })
        .catch(() => {
          this.addLoading = false;
        });
    },
    batchDeleteSubmit() {
      orderApi.check(this.batchDeleteForm).then((res) => {
        if (res.data.length > 0) {
          this.$confirm(`找到${res.data.length}条数据，确认删除吗`, "提示", {
            type: "warning",
          }).then(() => {
            orderApi
              .batchDelete({ ids: res.data.map((i) => i.id) })
              .then((res) => {
                if(res.code===0){
                  this.$message.success('删除成功')
                  this.batchDeleteVisible = false
                  this.getTpls()
                }
              });
          });
        } else {
          this.$message.error("没有找到数据");
        }
      });
    },
    handleBatchDel() {
      this.batchDeleteForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      };
      this.batchDeleteVisible = true;
    },
    editSubmit() {
      this.editLoading = true;
      orderApi
        .tplUpdate({
          id: this.editForm.id,
          price: this.editForm.price,
          breakfirst: this.editForm.breakfirst,
          name: this.editForm.name,
        })
        .then((r) => {
          this.$message({
            message: "修改成功",
            type: "success",
          });
          this.editLoading = false;
          this.editFormVisible = false;
          this.getTpls();
        })
        .catch((e) => {
          this.editLoading = false;
          this.$message({
            message: e.message,
            type: "error",
          });
        });
    },
    getTpls() {
      this.listLoading = true;
      const para = {
        page: this.page,
        search: this.search,
      };
      orderApi.tplList(para).then((res) => {
        this.listLoading = false;
        this.total = res.data.count;
        if (res.data.rows) {
          this.tableType = 1;
          res.data.rows.forEach((i) => (i.price = i.price / 100));
          this.tpls = res.data.rows;
        } else {
          this.tableType = 2;
          Object.keys(res.data).forEach(key=>{
            res.data[key].forEach(ii=>(ii.price = ii.price / 100))
          })
          this.listRes = res.data;
        }
      });
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTpls();
    },
    formatDate(row) {
      return row.tpl_date
        ? fecha.format(new Date(row.tpl_date), "YYYY-MM-DD")
        : "-";
    },
    handleBatchEdit(){
      this.batchEditForm = {
        hotel_id: "",
        range: [],
        name: "",
        price: '',
        breakfirst: 0,
        weekdays: [0, 1, 2, 3, 4, 5, 6],
      };
      this.batchEditVisible = true;
    },
    batchEditSubmit(){
      if(this.batchEditForm.price<=0){
        return this.$message.error('价格要大于0')
      }
      orderApi.check({...this.batchEditForm, ignorePrice: true}).then((res) => {
        if (res.data.length > 0) {
          this.$confirm(`找到${res.data.length}条数据，确认修改价格为${this.batchEditForm.price}`, "提示", {
            type: "warning",
          }).then(() => {
            orderApi
              .batchEdit({ ids: res.data.map((i) => i.id),price: this.batchEditForm.price })
              .then((res) => {
                if(res.code===0){
                  this.$message.success('修改成功')
                  this.batchEditVisible = false
                  this.getTpls()
                }
              });
          });
        } else {
          this.$message.error("没有找到数据");
        }
      });
    }
  },
  mounted() {
    this.getHotelMap();
    this.getTpls();
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?9d560bf8